import React from "react";
import useChatContextStore from "../../../../../../hooks/useChatContextStore";
import { defaultAttachmentProps } from "../../../../common/defaultProps/defaultAttachmentProps";
import { defaultAttachmentContentStyles } from "../defaultStyles/defaultAttachmentContentStyles";
import { defaultAttachmentDividerStyles } from "../defaultStyles/defaultAttachmentDividerStyles";
import { defaultAttachmentDownloadIconStyles } from "../defaultStyles/defaultAttachmentDownloadIconStyles";
import { defaultAttachmentFileNameStyles } from "../defaultStyles/defaultAttachmentFileNameStyles";
import { defaultAttachmentSizeStyles } from "../defaultStyles/defaultAttachmentSizeStyles";
import { defaultAttachmentIconStyles } from "../defaultStyles/defaultAtttachmentIconStyles";
import { defaultAttachmentStyles } from "../defaultStyles/defaultAtttachmentStyles";
import AttachmentContent from "./AttachmentContent";
import AttachmentIcon from "./AttachmentIcon";
const Attachment = props => {
  var _state$domainStates$r, _state$domainStates$r2, _state$domainStates$r3, _state$domainStates$r4, _state$domainStates$r5, _state$domainStates$r6, _state$domainStates$r7, _state$domainStates$r8, _state$domainStates$r9;
  // eslint-disable-line @typescript-eslint/no-explicit-any
  const {
    iconData,
    imageCard,
    textCard,
    renderer
  } = props;
  const [state] = useChatContextStore();
  const attachmentId = ((_state$domainStates$r = state.domainStates.renderingMiddlewareProps) === null || _state$domainStates$r === void 0 ? void 0 : (_state$domainStates$r2 = _state$domainStates$r.attachmentProps) === null || _state$domainStates$r2 === void 0 ? void 0 : _state$domainStates$r2.webChatAttachmentId) ?? defaultAttachmentProps.webChatAttachmentId;
  const attachmentDividerStyles = {
    ...defaultAttachmentDividerStyles,
    ...((_state$domainStates$r3 = state.domainStates.renderingMiddlewareProps) === null || _state$domainStates$r3 === void 0 ? void 0 : _state$domainStates$r3.attachmentDividerStyles)
  };
  const attachmentIconStyles = {
    ...defaultAttachmentIconStyles,
    ...((_state$domainStates$r4 = state.domainStates.renderingMiddlewareProps) === null || _state$domainStates$r4 === void 0 ? void 0 : _state$domainStates$r4.attachmentIconStyles)
  };
  const attachmentStyles = {
    ...defaultAttachmentStyles,
    ...((_state$domainStates$r5 = state.domainStates.renderingMiddlewareProps) === null || _state$domainStates$r5 === void 0 ? void 0 : _state$domainStates$r5.attachmentStyles)
  };
  const attachmentSizeStylesString = Object.entries({
    ...defaultAttachmentSizeStyles,
    ...((_state$domainStates$r6 = state.domainStates.renderingMiddlewareProps) === null || _state$domainStates$r6 === void 0 ? void 0 : _state$domainStates$r6.attachmentSizeStyles)
  }).map(_ref => {
    let [k, v] = _ref;
    return `${k.replace(/[A-Z]/g, match => `-${match.toLowerCase()}`)}:${v}`;
  }).join(";");
  const attachmentContentStylesString = Object.entries({
    ...defaultAttachmentContentStyles,
    ...((_state$domainStates$r7 = state.domainStates.renderingMiddlewareProps) === null || _state$domainStates$r7 === void 0 ? void 0 : _state$domainStates$r7.attachmentContentStyles)
  }).map(_ref2 => {
    let [k, v] = _ref2;
    return `${k.replace(/[A-Z]/g, match => `-${match.toLowerCase()}`)}:${v}`;
  }).join(";");
  const attachmentFileNameStylesString = Object.entries({
    ...defaultAttachmentFileNameStyles,
    ...((_state$domainStates$r8 = state.domainStates.renderingMiddlewareProps) === null || _state$domainStates$r8 === void 0 ? void 0 : _state$domainStates$r8.attachmentFileNameStyles)
  }).map(_ref3 => {
    let [k, v] = _ref3;
    return `${k.replace(/[A-Z]/g, match => `-${match.toLowerCase()}`)}:${v}`;
  }).join(";");
  const attachmentDownloadIconStylesString = Object.entries({
    ...defaultAttachmentDownloadIconStyles,
    ...((_state$domainStates$r9 = state.domainStates.renderingMiddlewareProps) === null || _state$domainStates$r9 === void 0 ? void 0 : _state$domainStates$r9.attachmentDownloadIconStyles)
  }).map(_ref4 => {
    let [k, v] = _ref4;
    return `${k.replace(/[A-Z]/g, match => `-${match.toLowerCase()}`)}:${v}`;
  }).join(";");
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("style", null, `
            .webchat__fileContent__size { ${attachmentSizeStylesString} }
            .webchat__fileContent { ${attachmentContentStylesString} }
            .webchat__fileContent__fileName { ${attachmentFileNameStylesString} }
            .webchat__fileContent__downloadIcon { ${attachmentDownloadIconStylesString} }
        `), /*#__PURE__*/React.createElement("div", {
    dir: state.domainStates.globalDir
  }, imageCard && renderer(imageCard), imageCard && /*#__PURE__*/React.createElement("hr", {
    id: attachmentId + "-divider",
    style: attachmentDividerStyles
  }), /*#__PURE__*/React.createElement(AttachmentContent, {
    attachment: textCard.attachment,
    id: attachmentId,
    style: attachmentStyles
  }, /*#__PURE__*/React.createElement(AttachmentIcon, {
    src: iconData,
    id: attachmentId + "-icon",
    style: attachmentIconStyles
  }), textCard && renderer(textCard))));
};
export default Attachment;